import { Box, Drawer, Typography } from '@mui/material';
import { FunctionComponent } from 'react';

import { PlacesQuery } from '../../../../../apollo/__generated__/graphql';
import { PlaceForm } from '../PlaceForm/PlaceForm';
import { useEditPlaceDrawer } from './useEditPlaceDrawer';

interface EditPlaceDrawerProps {
  isOpen: boolean;
  onClose: () => void;
  place: PlacesQuery['places'][number];
}

export const EditPlaceDrawer: FunctionComponent<EditPlaceDrawerProps> = ({
  isOpen,
  onClose,
  place,
}) => {
  const { errors, onSubmit, register } = useEditPlaceDrawer(place, onClose);

  return (
    <Drawer anchor="right" open={isOpen} onClose={onClose}>
      <Box sx={{ mt: 10, mx: 2 }}>
        <Typography variant="h4">Modifier un lieu</Typography>
        <PlaceForm
          register={register}
          onSubmit={onSubmit}
          errors={errors}
          submitButtonLabel="Modifier"
        />
      </Box>
    </Drawer>
  );
};
